
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAntennaOn as ObiAntennaOnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-antenna-on.js';
 
 
 

 
 export const ObiAntennaOn = createComponent({
   react: React,
   tagName: 'obi-antenna-on',
   elementClass: ObiAntennaOnElement,
   events: {
     
   }
  });
 
 